module.exports = __webpack_public_path__ + "static/media/Jax.36ffb83d.png";